/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface EmailsService {
  /**
   * @summary Queue Email
   * @description Queue a single email for processing
   */
  queueEmailEmailsSendPost: {
    /**
     * @summary Queue Email
     * @description Queue a single email for processing
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        QueueEmailEmailsSendPostBody,
        QueueEmailEmailsSendPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: QueueEmailEmailsSendPostSchema,
        options: ServiceOperationMutationFnOptions<
          QueueEmailEmailsSendPostBody,
          QueueEmailEmailsSendPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<QueueEmailEmailsSendPostData, QueueEmailEmailsSendPostError>>
    ): Promise<RequestFnResponse<QueueEmailEmailsSendPostData, QueueEmailEmailsSendPostError>>;
    /**
     * @summary Queue Email
     * @description Queue a single email for processing
     */
    getMutationKey(
      parameters: DeepReadonly<QueueEmailEmailsSendPostParameters> | void
    ): ServiceOperationMutationKey<QueueEmailEmailsSendPostSchema, QueueEmailEmailsSendPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Queue Email
     * @description Queue a single email for processing
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.emailsService.queueEmailEmailsSendPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.emailsService.queueEmailEmailsSendPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends QueueEmailEmailsSendPostBody, TContext = unknown>(
      parameters: DeepReadonly<QueueEmailEmailsSendPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        QueueEmailEmailsSendPostSchema,
        QueueEmailEmailsSendPostData,
        QueueEmailEmailsSendPostParameters,
        TVariables,
        OperationError<QueueEmailEmailsSendPostError>,
        TContext
      >
    ): UseMutationResult<
      QueueEmailEmailsSendPostData,
      OperationError<QueueEmailEmailsSendPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Queue Email
     * @description Queue a single email for processing
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.emailsService.queueEmailEmailsSendPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.emailsService.queueEmailEmailsSendPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<QueueEmailEmailsSendPostBody, QueueEmailEmailsSendPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        QueueEmailEmailsSendPostSchema,
        QueueEmailEmailsSendPostData,
        QueueEmailEmailsSendPostParameters,
        TVariables,
        OperationError<QueueEmailEmailsSendPostError>,
        TContext
      >
    ): UseMutationResult<
      QueueEmailEmailsSendPostData,
      OperationError<QueueEmailEmailsSendPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Queue Email
     * @description Queue a single email for processing
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const queueEmailEmailsSendPostTotal = qraft.emailsService.queueEmailEmailsSendPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const queueEmailEmailsSendPostTotal = qraft.emailsService.queueEmailEmailsSendPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            QueueEmailEmailsSendPostBody,
            QueueEmailEmailsSendPostData,
            QueueEmailEmailsSendPostParameters,
            OperationError<QueueEmailEmailsSendPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            QueueEmailEmailsSendPostSchema,
            QueueEmailEmailsSendPostBody,
            QueueEmailEmailsSendPostData,
            QueueEmailEmailsSendPostParameters,
            OperationError<QueueEmailEmailsSendPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Queue Email
     * @description Queue a single email for processing
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const queueEmailEmailsSendPostPendingMutationVariables = qraft.emailsService.queueEmailEmailsSendPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const queueEmailEmailsSendPostMutationData = qraft.emailsService.queueEmailEmailsSendPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        QueueEmailEmailsSendPostData,
        OperationError<QueueEmailEmailsSendPostError>,
        MutationVariables<QueueEmailEmailsSendPostBody, QueueEmailEmailsSendPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            QueueEmailEmailsSendPostBody,
            QueueEmailEmailsSendPostData,
            QueueEmailEmailsSendPostParameters,
            OperationError<QueueEmailEmailsSendPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            QueueEmailEmailsSendPostSchema,
            QueueEmailEmailsSendPostBody,
            QueueEmailEmailsSendPostData,
            QueueEmailEmailsSendPostParameters,
            OperationError<QueueEmailEmailsSendPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          QueueEmailEmailsSendPostData,
          OperationError<QueueEmailEmailsSendPostError>,
          MutationVariables<QueueEmailEmailsSendPostBody, QueueEmailEmailsSendPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Queue Email
     * @description Queue a single email for processing
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            QueueEmailEmailsSendPostBody,
            QueueEmailEmailsSendPostData,
            QueueEmailEmailsSendPostParameters,
            OperationError<QueueEmailEmailsSendPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            QueueEmailEmailsSendPostSchema,
            QueueEmailEmailsSendPostBody,
            QueueEmailEmailsSendPostData,
            QueueEmailEmailsSendPostParameters,
            OperationError<QueueEmailEmailsSendPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Queue Email
     * @description Queue a single email for processing
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.emailsService.queueEmailEmailsSendPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.emailsService.queueEmailEmailsSendPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              QueueEmailEmailsSendPostBody,
              QueueEmailEmailsSendPostData,
              QueueEmailEmailsSendPostParameters,
              OperationError<QueueEmailEmailsSendPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              QueueEmailEmailsSendPostSchema,
              QueueEmailEmailsSendPostBody,
              QueueEmailEmailsSendPostData,
              QueueEmailEmailsSendPostParameters,
              OperationError<QueueEmailEmailsSendPostError>,
              TContext
            >
      ):
        | Mutation<
            QueueEmailEmailsSendPostData,
            QueueEmailEmailsSendPostError,
            MutationVariables<QueueEmailEmailsSendPostBody, QueueEmailEmailsSendPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              QueueEmailEmailsSendPostBody,
              QueueEmailEmailsSendPostData,
              QueueEmailEmailsSendPostParameters,
              OperationError<QueueEmailEmailsSendPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              QueueEmailEmailsSendPostSchema,
              QueueEmailEmailsSendPostBody,
              QueueEmailEmailsSendPostData,
              QueueEmailEmailsSendPostParameters,
              OperationError<QueueEmailEmailsSendPostError>,
              TContext
            >
      ): Array<
        Mutation<
          QueueEmailEmailsSendPostData,
          QueueEmailEmailsSendPostError,
          MutationVariables<QueueEmailEmailsSendPostBody, QueueEmailEmailsSendPostParameters>,
          TContext
        >
      >;
    };
    schema: QueueEmailEmailsSendPostSchema;
    types: {
      parameters: QueueEmailEmailsSendPostParameters;
      data: QueueEmailEmailsSendPostData;
      error: QueueEmailEmailsSendPostError;
      body: QueueEmailEmailsSendPostBody;
    };
  };
}
/**
 * @summary Queue Email
 * @description Queue a single email for processing
 */
export const queueEmailEmailsSendPost = {
  schema: {
    method: 'post',
    url: '/emails/send',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: QueueEmailEmailsSendPostSchema;
  [QraftServiceOperationsToken]: EmailsService['queueEmailEmailsSendPost'];
};
export const emailsService = {
  queueEmailEmailsSendPost,
} as const;
type QueueEmailEmailsSendPostSchema = {
  method: 'post';
  url: '/emails/send';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type QueueEmailEmailsSendPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type QueueEmailEmailsSendPostData = paths['/emails/send']['post']['responses']['200']['content']['application/json'];
type QueueEmailEmailsSendPostError = paths['/emails/send']['post']['responses']['422']['content']['application/json'];
type QueueEmailEmailsSendPostBody = paths['/emails/send']['post']['requestBody']['content']['application/json'];
